import { clsx as t } from "clsx";
import { useRender as s } from "@base-ui/react/use-render";
var g = "_heading_1yz66_1", l = { heading: g }, _ = ({ level: a = 2, size: e = "md", color: r = "primary", render: d, ref: i, className: m, ...o }) => s({
  defaultTagName: `h${a}`,
  render: d,
  ref: i,
  props: {
    ...o,
    "data-size": e,
    "data-color": r,
    className: t(l.heading, m)
  }
});
export {
  _ as t
};
